/**
 * Hijri <-> Gregorian conversion (Umm al-Qura algorithmic approximation)
 * Based on the algorithm by Robert van Gent / Kuwaiti algorithm.
 * Sufficient for tracking certificate expiry dates.
 */

// Convert Gregorian date to Julian Day Number
function gregorianToJD(y, m, d) {
  if (m < 3) {
    y -= 1;
    m += 12;
  }
  const a = Math.floor(y / 100);
  const b = 2 - a + Math.floor(a / 4);
  return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1)) + d + b - 1524;
}

function jdToGregorian(jd) {
  jd = Math.floor(jd) + 0.5;
  const z = Math.floor(jd);
  let a;
  if (z < 2299161) {
    a = z;
  } else {
    const alpha = Math.floor((z - 1867216.25) / 36524.25);
    a = z + 1 + alpha - Math.floor(alpha / 4);
  }
  const b = a + 1524;
  const c = Math.floor((b - 122.1) / 365.25);
  const d = Math.floor(365.25 * c);
  const e = Math.floor((b - d) / 30.6001);
  const day = b - d - Math.floor(30.6001 * e);
  const month = e < 14 ? e - 1 : e - 13;
  const year = month > 2 ? c - 4716 : c - 4715;
  return { y: year, m: month, d: day };
}

// Hijri to JD (Kuwaiti algorithm - good approximation)
function hijriToJD(hy, hm, hd) {
  return Math.floor((11 * hy + 3) / 30) + 354 * hy + 30 * hm - Math.floor((hm - 1) / 2) + hd + 1948440 - 385;
}

function jdToHijri(jd) {
  jd = Math.floor(jd) + 0.5;
  const y = Math.floor((30 * (jd - 1948439.5) + 10646) / 10631);
  const m = Math.min(12, Math.ceil((jd - (29 + hijriToJD(y, 1, 1))) / 29.5) + 1);
  const d = Math.floor(jd - hijriToJD(y, m, 1)) + 1;
  return { y, m, d };
}

export function hijriToGregorian(hy, hm, hd) {
  const jd = hijriToJD(hy, hm, hd);
  return jdToGregorian(jd);
}

export function gregorianToHijri(gy, gm, gd) {
  const jd = gregorianToJD(gy, gm, gd);
  return jdToHijri(jd);
}

export function todayHijri() {
  const now = new Date();
  return gregorianToHijri(now.getFullYear(), now.getMonth() + 1, now.getDate());
}

// Days remaining until Hijri date (negative = expired)
export function daysUntilHijri(h) {
  if (!h || !h.y) return null;
  const g = hijriToGregorian(h.y, h.m, h.d);
  const target = new Date(g.y, g.m - 1, g.d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.floor((target - today) / (1000 * 60 * 60 * 24));
  return diff;
}

export function statusOf(h) {
  const d = daysUntilHijri(h);
  if (d === null) return "missing";
  if (d < 0) return "expired";
  if (d <= 30) return "warning";
  return "valid";
}

export const HIJRI_MONTHS = [
  "محرم", "صفر", "ربيع الأول", "ربيع الآخر",
  "جمادى الأولى", "جمادى الآخرة", "رجب", "شعبان",
  "رمضان", "شوال", "ذو القعدة", "ذو الحجة",
];

export function formatHijri(h) {
  if (!h || !h.y) return "—";
  return `${String(h.d).padStart(2, "0")}/${String(h.m).padStart(2, "0")}/${h.y}`;
}

export function formatHijriLong(h) {
  if (!h || !h.y) return "—";
  return `${h.d} ${HIJRI_MONTHS[h.m - 1]} ${h.y}هـ`;
}

// Year range for dropdowns
export function hijriYears() {
  const cur = todayHijri().y;
  const years = [];
  for (let y = cur - 5; y <= cur + 10; y++) years.push(y);
  return years;
}

export function daysInHijriMonth(y, m) {
  // Approximate: odd months 30, even months 29; month 12 varies but we use 30
  if (m === 12) return 30;
  return m % 2 === 1 ? 30 : 29;
}
